import React, { Component } from 'react';
import { connect } from 'react-redux';
import First from './First';

class PageTree extends Component {
  render () {
    const { value = [], label = {}, onChange, disabled = false } = this.props;
    const { list: lList = [] } = label;
    return (
      <div style={{}}>
        {lList.map((o, i) => (
          <First key={i} data={o} value={value} onChange={onChange} disabled={disabled} />
        ))}
      </div>
    );
  }
}

const mapStateToProps = state => ({
});
const mapDispatchToProps = dispatch => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(PageTree);
